interface UmamiTracker {
    track: {
        (): void;
        (eventName: string): void;
        (eventName: string, data: Record<string, string | number | boolean>): void;
        (payload: Record<string, string | number | boolean>): void;
        (callback: (props: Record<string, string | number | boolean>) => Record<string, string | number | boolean>): void;
    };
    identify: {
        (uniqueId: string): void;
        (uniqueId: string, data: Record<string, string | number | boolean>): void;
        (data: Record<string, string | number | boolean>): void;
    };
}

declare global {
    interface Window {
        umami?: UmamiTracker;
    }
}

export const trackUmami = (eventValue: string) => {
    if (!window.umami || typeof window.umami.track !== 'function') {
        return;
    }

    try {
        window.umami.track(eventValue);
    } catch (e) {
        console.warn('failed to track an event with Umami', e);
    }
};
